import React from 'react';
import { Title } from 'scy/text';
import { DarkBackground } from 'scy/Background';
import { hidden, tablet_block } from 'scy/display.mod.scss';
import styles from './categories.mod.scss';

const CATEGORIES = [
  { id: 'tequila', title: 'Tequila', href: '/tequila-mezcal' },
  { id: 'whiskey', title: 'Whiskey', href: '/whiskey' },
  { id: 'vodka', title: 'Vodka', href: '/vodka' },
  { id: 'wine', title: 'Wine', href: '/wine' },
  { id: 'beer', title: 'Beer', href: '/beer' }
];

const List = () =>
  CATEGORIES.map(category => <Item key={category.id} {...category} />);

const Item = ({ href, id, title }) => {
  return (
    <a href={href} className={styles.item}>
      <DarkBackground className={`${styles.image} ${styles[id]}`}>
        <Title className={styles.title}>
          <div className={`${hidden} ${tablet_block}`}>Shop</div>
          {title}
        </Title>
      </DarkBackground>
    </a>
  );
};

export default List;
